import { dateTime, eur } from "@/lib/format";

export const ACCOUNT_STATUS_STYLES = {
  ACTIVE: "bg-emerald-50 text-emerald-800 border-emerald-200",
  PAUSED: "bg-amber-50 text-amber-800 border-amber-200",
  INVITED: "bg-blue-50 text-blue-800 border-blue-200",
  BLOCKED: "bg-red-50 text-red-800 border-red-200",
  CANCELLED: "bg-slate-100 text-slate-600 border-slate-200",
};

export const SUBSCRIPTION_STATUS_STYLES = {
  TRIAL: "bg-violet-50 text-violet-800 border-violet-200",
  ACTIVE: "bg-emerald-50 text-emerald-800 border-emerald-200",
  PAYMENT_DUE: "bg-amber-50 text-amber-800 border-amber-200",
  PAST_DUE: "bg-red-50 text-red-800 border-red-200",
  CANCELLED: "bg-slate-100 text-slate-600 border-slate-200",
  MANUAL: "bg-slate-100 text-slate-700 border-slate-200",
};

export const StatusBadge = ({ status, styles = ACCOUNT_STATUS_STYLES, testid }) => (
  <span
    data-testid={testid}
    className={`chip border text-[10px] font-bold uppercase tracking-[0.06em] ${
      styles[status] || "bg-slate-100 text-slate-600 border-slate-200"
    }`}
  >
    {(status || "—").replace("_", " ")}
  </span>
);

export const AccountTable = ({ accounts, onOpen, onStatus, onImpersonate, busyId }) => (
  <div className="overflow-x-auto">
    <table className="data-table" data-testid="admin-accounts-table">
      <thead>
        <tr>
          <th>Klant</th>
          <th>Contactpersoon</th>
          <th>E-mail</th>
          <th>Status</th>
          <th>Abonnement</th>
          <th className="num">Prijs p/m</th>
          <th>Laatste login</th>
          <th>Aangemaakt</th>
          <th className="num">Acties</th>
        </tr>
      </thead>
      <tbody>
        {accounts.map((account) => {
          const user = account.user || {};
          const pricing = account.pricing || {};
          const subscription = account.subscription || {};
          const paused = account.account_status !== "ACTIVE";
          return (
            <tr key={account.id} data-testid={`admin-account-row-${account.id}`}>
              <td>
                <button
                  type="button"
                  onClick={() => onOpen(account)}
                  data-testid={`admin-open-${account.id}`}
                  className="font-medium text-blue-700 hover:underline"
                >
                  {account.name}
                </button>
                <div className="mt-0.5 flex items-center gap-1">
                  {account.is_master && <span className="chip bg-slate-900 text-white">MASTER</span>}
                  {account.is_test_account && (
                    <span className="chip bg-slate-100 text-slate-600">TEST</span>
                  )}
                </div>
              </td>
              <td>{user.name || "—"}</td>
              <td className="mono text-[11px]">{user.email || account.email || "—"}</td>
              <td>
                <StatusBadge
                  status={account.account_status}
                  testid={`admin-status-${account.id}`}
                />
              </td>
              <td>
                <StatusBadge
                  status={subscription.status}
                  styles={SUBSCRIPTION_STATUS_STYLES}
                  testid={`admin-subscription-${account.id}`}
                />
                <div className="mt-0.5 text-[11px] text-slate-500">{pricing.plan_name || "—"}</div>
              </td>
              <td className="num mono">
                {eur(pricing.effective_price, { fallback: "—" })}
                {pricing.custom_price != null && (
                  <div className="text-[10px] font-normal text-amber-700">afwijkend</div>
                )}
              </td>
              <td className="mono text-[11px]">{dateTime(user.last_login_at)}</td>
              <td className="mono text-[11px]">{dateTime(account.created_at)}</td>
              <td className="num">
                <div className="flex justify-end gap-1">
                  <button
                    type="button"
                    onClick={() => onOpen(account)}
                    data-testid={`admin-view-${account.id}`}
                    className="btn-ghost"
                  >
                    Bekijken
                  </button>
                  {!account.is_master && (
                    <>
                      <button
                        type="button"
                        disabled={busyId === account.id}
                        onClick={() => onStatus(account, paused ? "ACTIVE" : "PAUSED")}
                        data-testid={`admin-toggle-status-${account.id}`}
                        className="btn-ghost"
                      >
                        {paused ? "Activeren" : "Pauzeren"}
                      </button>
                      <button
                        type="button"
                        disabled={busyId === account.id}
                        onClick={() => onImpersonate(account)}
                        data-testid={`admin-impersonate-${account.id}`}
                        className="btn-ghost"
                      >
                        Account openen
                      </button>
                    </>
                  )}
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);
